import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=1b590bce&scoped=true&lang=pug&"
import script from "./Animation.vue?vue&type=script&lang=js&"
export * from "./Animation.vue?vue&type=script&lang=js&"
import style0 from "./Animation.vue?vue&type=style&index=0&id=1b590bce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b590bce",
  null
  
)

export default component.exports